import FaqItem from './faq-item.vue'


export default {
  __name: 'faq-list',
  props: {
  title: {
    type: String,
    default: undefined,
  },
  items: {
    type: Array,
    required: true,
    default: () => [],
  },
},
  setup(__props) {



return { __sfc: true,FaqItem }
}

}